import { useState } from 'react';
import { useSEO } from '@/hooks/useSEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTopButton from '@/components/feature/ScrollToTopButton';
import Breadcrumb from '@/components/feature/Breadcrumb';

const testimonials = [
  {
    name: '张先生',
    role: '资深网购用户',
    content: '自从用了福利导航在线，我每个月光返利就能省下300多块。最棒的是所有信息都整理得清清楚楚，再也不用自己到处找了。',
    rating: 5,
  },
  {
    name: '李女士',
    role: '全职妈妈',
    content: '作为一个精打细算的家庭主妇，福利导航在线简直就是我的省钱神器！外卖红包、购物返利、免费试用，每一样都超级实用。',
    rating: 5,
  },
  {
    name: '王同学',
    role: '大学生',
    content: '学生党预算有限，福利导航在线帮我找到了很多免费会员和试用机会。B站大会员和爱奇艺会员都是通过这里的攻略免费拿到的！',
    rating: 5,
  },
  {
    name: '陈先生',
    role: '上班族',
    content: '信用卡权益那一块特别实用，我之前都不知道自己的信用卡有那么多隐藏福利。按照攻略操作，今年光机场贵宾厅就用了好几次。',
    rating: 5,
  },
  {
    name: '刘女士',
    role: '自由职业者',
    content: '福利导航在线更新很及时，每次有大促活动都能第一时间看到攻略。今年618通过隐藏优惠券省了将近1000块，太给力了！',
    rating: 5,
  },
  {
    name: '赵先生',
    role: 'IT工程师',
    content: '页面很清爽，分类也很清晰。最重要的是信息真实有效，不像有些平台全是过期的优惠信息。已经成为我每天必刷的网站了。',
    rating: 5,
  },
];

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '福利导航在线',
  url: 'https://fulidaohang.online',
  description: '一站式福利资源聚合平台，为您精选全网优质福利资源，涵盖生活优惠、会员权益、折扣活动等多类福利内容。',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'contact@fulidaohang.online',
    availableLanguage: 'Chinese',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '福利导航在线是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '福利导航在线是一个一站式福利资源聚合平台，专注为用户精选全网优质的福利资源，涵盖购物返利、免费试用、会员权益、折扣优惠、生活福利、金融福利等六大品类。',
      },
    },
    {
      '@type': 'Question',
      name: '福利导航在线的资源是否免费？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '是的，福利导航在线平台上的所有福利资源均为免费聚合和展示，用户可以免费浏览和使用。部分福利资源可能需要满足特定条件方可领取。',
      },
    },
    {
      '@type': 'Question',
      name: '福利导航在线的资源多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '福利导航在线每日更新福利资源内容，确保用户获取到最新、最有效的福利信息。限时福利会标注有效期限。',
      },
    },
    {
      '@type': 'Question',
      name: '如何联系福利导航在线？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过本页面下方的联系表单与我们取得联系，也可以发送邮件至 contact@fulidaohang.online，我们会在24小时内回复。',
      },
    },
  ],
};

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useSEO({
    title: '关于我们 - 福利导航在线',
    description: '福利导航在线是一站式福利资源聚合平台，专注为用户精选全网优质福利资源。了解我们的品牌故事、用户口碑和联系方式。',
    keywords: '福利导航在线,关于福利导航,福利资源平台,联系我们',
    canonicalUrl: 'https://fulidaohang.online/about',
    schema: { ...orgSchema, ...faqSchema },
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('submitting');
    setFormError('');

    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setFormStatus('success');
      return;
    }

    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9qoa7cnlsngrm4lm2s0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormError('提交失败，请稍后重试');
        } else {
          setFormError(serverMsg);
        }
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络后重试');
      setFormStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-20">
        <section className="relative w-full h-[200px] md:h-[280px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-secondary-500/90 to-primary-500/90"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-2">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-background-200 max-w-xl mx-auto">
              了解福利导航在线的品牌故事、发展历程和联系方式
            </p>
          </div>
        </section>

        <section className="py-6 md:py-8 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb items={[{ name: '首页', path: '/' }, { name: '关于我们' }]} />
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                  品牌介绍
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  福利导航在线成立于2024年，是一个专注于福利资源聚合与导航的综合服务平台。我们致力于为广大用户提供最新、最全、最实用的福利信息资源，帮助每一位用户在日常生活中发现更多实惠与惊喜。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  平台目前涵盖<strong>购物返利</strong>、<strong>免费试用</strong>、<strong>会员权益</strong>、<strong>折扣优惠</strong>、<strong>生活福利</strong>、<strong>金融福利</strong>六大核心品类，每日更新福利资源超过200条，月活跃用户超过50万人。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  我们的使命是让每一位用户都能轻松享受到全网最优质的福利资源，让省钱成为一种生活方式。
                </p>
              </div>
              <div className="relative w-full h-64 md:h-80 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimal%20office%20workspace%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20team%20collaboration%20concept%2C%20clean%20and%20bright%20atmosphere%2C%20natural%20light%2C%20creative%20workspace%20with%20plants%20and%20wooden%20furniture%2C%20professional%20yet%20friendly%20vibe&width=800&height=600&seq=about-brand-2026&orientation=landscape"
                  alt="福利导航在线团队"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
              平台数据
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {[
                { value: '200+', label: '精选福利资源' },
                { value: '6', label: '福利分类' },
                { value: '50万+', label: '月活跃用户' },
                { value: '99.8%', label: '用户满意度' },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="text-center p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/60"
                >
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8 text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className="p-5 bg-background-50 rounded-lg border border-background-200/60"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, j) => (
                      <i key={j} className="ri-star-fill text-sm text-primary-400"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "{t.content}"
                  </p>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">
                  联系我们
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式与我们取得联系。我们会在24小时内回复您的消息。
                </p>
                <div className="flex flex-col gap-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <div className="text-xs text-foreground-500">电子邮箱</div>
                      <div className="text-sm font-medium text-foreground-900">contact@fulidaohang.online</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className="ri-wechat-line text-lg"></i>
                    </div>
                    <div>
                      <div className="text-xs text-foreground-500">微信公众号</div>
                      <div className="text-sm font-medium text-foreground-900">福利导航在线</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                      <i className="ri-time-line text-lg"></i>
                    </div>
                    <div>
                      <div className="text-xs text-foreground-500">工作时间</div>
                      <div className="text-sm font-medium text-foreground-900">周一至周五 9:00-18:00</div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-4">
                  发送消息
                </h3>
                <form
                  onSubmit={handleSubmit}
                  data-readdy-form=""
                  className="flex flex-col gap-4"
                >
                  <input
                    type="text"
                    name="phone_alt"
                    autoComplete="off"
                    tabIndex={-1}
                    aria-hidden="true"
                    readOnly
                    className="contact-form-hp"
                  />
                  <div>
                    <label htmlFor="about-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      您的姓名 <span className="text-secondary-500">*</span>
                    </label>
                    <input
                      id="about-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/60 rounded-md text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      电子邮箱 <span className="text-secondary-500">*</span>
                    </label>
                    <input
                      id="about-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/60 rounded-md text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的电子邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="about-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      留言内容 <span className="text-secondary-500">*</span>
                    </label>
                    <textarea
                      id="about-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200/60 rounded-md text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                      placeholder="请输入您想说的话，不超过500字"
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    disabled={formStatus === 'submitting'}
                    className="w-full py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                  >
                    {formStatus === 'submitting' ? '发送中...' : '发送消息'}
                  </button>
                  {formStatus === 'success' && (
                    <p className="text-sm text-accent-600 text-center">
                      消息已发送成功！我们会尽快回复您。
                    </p>
                  )}
                  {formStatus === 'error' && (
                    <p className="text-sm text-secondary-600 text-center">{formError}</p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 text-center">
              常见问题
            </h2>
            <div className="flex flex-col gap-3">
              {[
                { q: '福利导航在线是什么？', a: '福利导航在线是一个一站式福利资源聚合平台，专注为用户精选全网优质的福利资源，涵盖购物返利、免费试用、会员权益、折扣优惠、生活福利、金融福利等六大品类，所有资源均免费向用户开放。' },
                { q: '福利导航在线的资源是否免费？', a: '是的，福利导航在线平台上的所有福利资源均为免费聚合和展示，用户可以免费浏览和使用。部分福利资源可能需要满足特定条件（如新用户、特定支付方式等）方可领取，我们会在文章中详细说明。' },
                { q: '福利导航在线的资源多久更新一次？', a: '福利导航在线每日更新福利资源内容，确保用户获取到最新、最有效的福利信息。限时福利会标注有效期限，建议用户及时使用以免过期。' },
                { q: '如何联系福利导航在线？', a: '您可以通过本页面的联系表单与我们取得联系，也可以发送邮件至 contact@fulidaohang.online，我们的客服团队会在24小时内回复您的消息。' },
              ].map((faq, i) => (
                <div key={i} className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/60">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                    Q: {faq.q}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    A: {faq.a}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <ScrollToTopButton />
    </div>
  );
}